// Importing SVG icons
import {
  DashboardIcon,
  JobsIcon,
  TotalApplicantsIcon,
  ScheduledInterviewsIcon,
  HelpCenterIcon,
  LogOutIcon,
} from '@assets/Icons';

export const leftSidebarTopItems = [
  { to: '/dashboard', icon: DashboardIcon, label: 'Dashboard' },
  { to: '/jobs', icon: JobsIcon, label: 'Your Jobs' },
  { to: '/candidates', icon: TotalApplicantsIcon, label: 'Shortlisted Candidates' },
  { to: '/interviews', icon: ScheduledInterviewsIcon, label: 'Interviews' },
];

export const leftSidebarBottomItems = [
  { to: '/help', icon: HelpCenterIcon, label: 'Help Center', disabled: true },
  { icon: LogOutIcon, label: 'Log out' },
];